import { useCallback } from 'react';
import { useTranslations } from 'js/hooks/i18n';
import { ERRORS } from 'js/components/main/ReCaptcha';

export const useRecaptchaErrorHandler = ({ setError, setIsRecaptchaVisible }) => {
    const t = useTranslations('playtech.mobile.system.recaptcha.');

    return useCallback(({ errorCode }) => {
        if (errorCode === ERRORS.SCRIPT_LOADING_ERROR.errorCode) {
            setIsRecaptchaVisible(false);
        }

        setError(t('error.technicalError'));
    }, [setIsRecaptchaVisible, setError, t]);
};
